/**
 * Activity log contracts (docs/adr/ADR-007): who changed what and when, for the
 * operations that matter for security and for the data of the modules.
 */
export const AUDIT_ACTIONS = [
    'user.created',
    'user.updated',
    'profile.created',
    'profile.updated',
    'profile.deleted',
    'table.created',
    'table.entry-created',
    'organization.role-users',
    'table.entries-imported',
    'table.entry-updated',
    'table.entry-deleted',
    'table.entry-moved',
    'table.list-duplicated',
    'table.version-created',
    'table.version-activated',
    'table.version-deleted',
    'subject.created',
    'subject.updated',
    'subject.role-added',
    'subject.role-updated',
    'subject.classified',
    'subject.folder-created',
    'subject.file-uploaded',
    'subject.file-deleted',
    'subject.contacts-changed',
    'subject.aliases-changed',
    'subject.owner-changed',
    'subject.shared',
    'subject.unshared',
    'subject.unlock-requested',
    'subject.unlock-decided',
    'subject.imported',
    'quote.created',
    'quote.updated',
    'quote.lines-changed',
    'quote.line-added',
    'quote.licences-calculated',
    'quote.line-changed',
    'quote.line-removed',
    'quote.deleted',
    'quote.issued',
    'quote.approved',
    'quote.validation-requested',
    'quote.validated',
    'quote.state-changed',
    'quote.revised',
    'quote.duplicated',
    'quote.document-discount-set',
    'quote.document-discount-removed',
    'quote.cost-set',
    'quote.cost-added',
    'quote.cost-changed',
    'quote.lists-changed',
    'quote.section-added',
    'quote.section-renamed',
    'quote.section-removed',
    'quote.cost-removed',
    'quote.linked',
    'quote.unlinked',
    'quote.document-downloaded',
    'quote.owner-changed',
    'quote.folder-created',
    'quote.file-uploaded',
    'quote.file-deleted',
    'quote.document-prepared',
    'quote.installments-changed',
    'quote.log-added',
    'quote.log-changed',
    'quote.log-removed',
    'quote.conditions-version',
    'treasury.invoices-imported',
    'treasury.invoice-updated',
    'treasury.settlement-added',
    'treasury.settlement-removed',
    'treasury.closure-document',
    'treasury.invoice-cancelled',
    'treasury.hold-created',
    'treasury.hold-updated',
    'treasury.hold-resumed',
    'treasury.holds-settled',
    'treasury.year-closed',
    'treasury.year-reopened',
    'treasury.invoice-restored',
    'treasury.credit-linked',
    'treasury.credit-unlinked',
    'treasury.compensated',
    'treasury.compensation-undone',
    'treasury.registry-proposal-dismissed',
    'treasury.registry-proposal-restored',
    'treasury.invoice-created',
    'treasury.invoice-deleted',
    'treasury.proforma-replaced',
    'treasury.proforma-restored',
    'treasury.advance-linked',
    'treasury.advance-unlinked',
    'treasury.advance-retained',
    'treasury.subject-payment-added',
    'treasury.subject-payment-removed',
    'treasury.subject-payment-used',
    'treasury.payments-reallocated',
    'treasury.invoice-xml-stored',
    'treasury.ledger-imported',
    'treasury.ledger-linked',
    'treasury.ledger-matches-confirmed',
    'treasury.opening-fixed',
    'treasury.opening-unfixed',
    'treasury.opening-moved',
    'treasury.loan-created',
    'treasury.loan-updated',
    'treasury.loan-deleted',
    'treasury.loan-schedule-imported',
    'treasury.card-saved',
    'treasury.card-deleted',
    'treasury.cards-loaded',
    'treasury.cards-load-removed',
    'treasury.card-reconciled',
    'treasury.card-unreconciled',
    'treasury.card-rule-saved',
    'treasury.card-rule-deleted',
    'treasury.bank-saved',
    'treasury.statement-loaded',
    'treasury.statement-removed',
    'treasury.movement-reconciled',
    'treasury.movement-unreconciled',
    'treasury.movement-added',
    'treasury.transfer-paired',
    'treasury.subject-payment-no-invoice',
    'treasury.subject-payment-document',
    'treasury.instalment-plan-saved',
    'treasury.instalment-plan-deleted',
    'treasury.f24-saved',
    'treasury.f24-deleted',
    'treasury.subject-statement-exported',
    'treasury.bank-movements-exported',
    'treasury.card-movements-exported',
    'reclass.plan-saved',
    'reclass.plan-deleted',
    'reclass.item-saved',
    'reclass.item-removed',
    'reclass.items-imported',
    'reclass.items-ordered',
    'people.employee-created',
    'people.employee-updated',
    'people.salary-saved',
    'people.salary-payment-added',
    'people.salary-payment-removed',
    'people.tfr-payment-added',
    'people.tfr-payment-removed',
    'people.tfr-coverage-saved',
    'people.payroll-loaded',
    'people.payroll-replaced',
    'people.rate-added',
    'people.rate-updated',
    'people.rate-removed',
    'job.created',
    'job.updated',
    'job.people-changed',
    'job.state-changed',
    'job.deleted',
    'job.offer-linked',
    'job.offer-unlinked',
    'job.child-created',
    'job.installment-saved',
    'job.installment-removed',
    'job.installment-moved',
    'job.installment-released',
    'job.cost-released',
    'job.installment-proforma-linked',
    'job.installment-proforma-unlinked',
    'job.cost-proforma-linked',
    'job.cost-proforma-unlinked',
    'job.invoice-allocated',
    'job.cost-saved',
    'job.cost-settled',
    'job.cost-reopened',
    'job.cost-removed',
    'job.cost-moved',
    'job.indicator-added',
    'job.indicator-updated',
    'job.indicator-removed',
    'job.measure-added',
    'job.measure-removed',
    'project-area.access-changed',
    'job.resources-changed',
    'job.hours-added',
    'job.hours-removed',
    'job.hours-synced',
    'job.progress',
    'job.risk-added',
    'job.risk-updated',
    'job.invoice-excluded',
    'job.invoice-included',
    'job.invoice-dismissed',
    'job.invoice-restored',
    'treasury.schedule-updated',
    'treasury.planned-transfer-created',
    'treasury.planned-transfer-updated',
    'treasury.planned-transfer-deleted',
    'treasury.planned-transfer-done',
];
export const AUDIT_ACTION_LABELS = {
    'user.created': 'Utente creato',
    'user.updated': 'Utente modificato',
    'profile.created': 'Ruolo creato',
    'profile.updated': 'Ruolo modificato',
    'profile.deleted': 'Ruolo eliminato',
    'table.created': 'Tabella creata',
    'table.entry-created': 'Voce aggiunta',
    'organization.role-users': 'Utenti di un ruolo aziendale',
    'table.entries-imported': 'Voci importate da file',
    'table.entry-updated': 'Voce modificata',
    'table.entry-deleted': 'Voce eliminata',
    'table.entry-moved': 'Voce spostata',
    'table.list-duplicated': 'Listino duplicato',
    'table.version-created': 'Nuova versione di tabella',
    'table.version-activated': 'Versione di tabella attivata',
    'table.version-deleted': 'Bozza di tabella eliminata',
    'subject.created': 'Soggetto creato',
    'subject.updated': 'Soggetto modificato',
    'subject.role-added': 'Ruolo aggiunto a un soggetto',
    'subject.role-updated': 'Ruolo di un soggetto modificato',
    'subject.classified': 'Classificazioni di un soggetto',
    'subject.folder-created': 'Cartella dei documenti creata',
    'subject.file-uploaded': 'File caricato',
    'subject.file-deleted': 'File eliminato',
    'subject.contacts-changed': 'Contatti di un soggetto',
    'subject.aliases-changed': 'Alias di un soggetto',
    'subject.owner-changed': 'Soggetto assegnato a un altro utente',
    'subject.shared': 'Soggetto sbloccato per un utente',
    'subject.unshared': 'Sblocco di un soggetto revocato',
    'subject.unlock-requested': 'Richiesta di sblocco',
    'subject.unlock-decided': 'Richiesta di sblocco decisa',
    'subject.imported': 'Import di anagrafiche',
    'quote.created': 'Preventivo creato',
    'quote.updated': 'Preventivo modificato',
    'quote.lines-changed': 'Righe di un preventivo',
    'quote.line-added': 'Riga aggiunta a un preventivo',
    'quote.licences-calculated': 'Licenze calcolate sul listino',
    'quote.line-changed': 'Riga di un preventivo modificata',
    'quote.line-removed': 'Riga tolta da un preventivo',
    'quote.deleted': 'Bozza di preventivo eliminata',
    'quote.issued': 'Preventivo emesso',
    'quote.approved': 'Preventivo approvato: offerta creata',
    'quote.validation-requested': 'Convalida del CFO chiesta',
    'quote.validated': 'Convalida del CFO',
    'quote.state-changed': 'Stato di un’offerta',
    'quote.revised': 'Nuova versione di un’offerta',
    'quote.duplicated': 'Preventivo duplicato',
    'quote.document-discount-set': 'Sconto sul documento',
    'quote.document-discount-removed': 'Sconto sul documento tolto',
    'quote.cost-set': 'Costo previsto scelto',
    'quote.cost-added': 'Costo previsto aggiunto',
    'quote.cost-changed': 'Costo previsto modificato',
    'quote.lists-changed': 'Listini cambiati',
    'quote.section-added': 'Sezione compilata da listino',
    'quote.section-renamed': 'Sezione rinominata',
    'quote.section-removed': 'Sezione eliminata',
    'quote.cost-removed': 'Costo previsto tolto',
    'quote.linked': 'Preventivo collegato',
    'quote.unlinked': 'Preventivo scollegato',
    'quote.document-downloaded': 'Documento scaricato in Word',
    'quote.owner-changed': 'Commerciale di riferimento cambiato',
    'quote.folder-created': 'Cartella dei documenti di un’offerta',
    'quote.file-uploaded': 'File caricato in un’offerta',
    'quote.file-deleted': 'File eliminato da un’offerta',
    'quote.document-prepared': 'Documento dell’offerta preparato da modello',
    'quote.installments-changed': 'Piano di pagamento',
    'quote.log-added': 'Nota nel diario della trattativa',
    'quote.log-changed': 'Nota del diario corretta',
    'quote.log-removed': 'Nota del diario eliminata',
    'quote.conditions-version': 'Nuova versione per le condizioni',
    'treasury.invoices-imported': 'Fatture lette da Gestify',
    'treasury.invoice-updated': 'Fattura aggiornata',
    'treasury.settlement-added': 'Incasso o pagamento segnato',
    'treasury.settlement-removed': 'Incasso o pagamento tolto',
    'treasury.closure-document': 'Documento di una chiusura senza movimento',
    'treasury.invoice-cancelled': 'Fattura annullata',
    'treasury.hold-created': 'Messo in sospeso (Da sistemare)',
    'treasury.hold-updated': 'Sospeso modificato',
    'treasury.hold-resumed': 'Sospeso ripreso',
    'treasury.holds-settled': 'Sospesi chiusi perché sistemati',
    'treasury.year-closed': 'Anno della Tesoreria chiuso',
    'treasury.year-reopened': 'Anno della Tesoreria riaperto',
    'treasury.invoice-restored': 'Fattura ripristinata',
    'treasury.credit-linked': 'Nota di credito collegata a una fattura',
    'treasury.credit-unlinked': 'Collegamento della nota di credito annullato',
    'treasury.compensated': 'Compensata con una fattura dello stesso soggetto',
    'treasury.compensation-undone': 'Compensazione annullata',
    'treasury.registry-proposal-dismissed': 'Proposta per l’Anagrafica ignorata',
    'treasury.registry-proposal-restored': 'Proposta per l’Anagrafica ripresa',
    'treasury.invoice-created': 'Documento inserito a mano',
    'treasury.invoice-deleted': 'Documento inserito a mano eliminato',
    'treasury.proforma-replaced': 'Pro-forma sostituita dalle fatture',
    'treasury.proforma-restored': 'Sostituzione della pro-forma annullata',
    'treasury.advance-linked': 'Fattura collegata a un anticipo della banca',
    'treasury.advance-unlinked': 'Fattura tolta da un anticipo della banca',
    'treasury.advance-retained': 'Anticipo chiuso con l’incasso di un’altra fattura',
    'treasury.subject-payment-added': 'Pagamento o incasso imputato al soggetto senza documento',
    'treasury.subject-payment-removed': 'Tolto un pagamento o incasso senza documento',
    'treasury.subject-payment-used': 'Pagamento o incasso senza documento usato su una fattura',
    'treasury.payments-reallocated': 'Pagamenti riabbinati alle fatture in ordine di data',
    'treasury.invoice-xml-stored': 'Fattura elettronica letta da Gestify',
    'treasury.ledger-imported': 'Mastrino dell’anno caricato',
    'treasury.ledger-linked': 'Soggetto del mastrino abbinato',
    'treasury.ledger-matches-confirmed': 'Abbinamenti dai mastrini confermati',
    'treasury.opening-fixed': 'Situazione iniziale fissata',
    'treasury.opening-unfixed': 'Situazione iniziale ricalcolata',
    'treasury.opening-moved': 'Situazione iniziale spostata a un altro 1° gennaio',
    'treasury.loan-created': 'Finanziamento inserito',
    'treasury.loan-updated': 'Finanziamento modificato',
    'treasury.loan-deleted': 'Finanziamento eliminato',
    'treasury.loan-schedule-imported': 'Piano di ammortamento caricato',
    'treasury.card-saved': 'Carta di credito salvata',
    'treasury.card-deleted': 'Carta di credito eliminata',
    'treasury.cards-loaded': 'Spese delle carte caricate',
    'treasury.cards-load-removed': 'Caricamento delle carte tolto',
    'treasury.card-reconciled': 'Spesa con carta rendicontata',
    'treasury.card-unreconciled': 'Rendicontazione di una spesa annullata',
    'treasury.card-rule-saved': 'Regola delle carte salvata',
    'treasury.card-rule-deleted': 'Regola delle carte tolta',
    'treasury.bank-saved': 'Conto della Tesoreria salvato',
    'treasury.statement-loaded': 'Estratto conto caricato',
    'treasury.statement-removed': 'Estratto conto tolto',
    'treasury.movement-reconciled': 'Movimento riconciliato',
    'treasury.movement-unreconciled': 'Riconciliazione annullata',
    'treasury.movement-added': 'Movimento bancario aggiunto a mano',
    'treasury.transfer-paired': 'Giroconto abbinato',
    'treasury.subject-payment-no-invoice': 'Pagamento senza fattura (costo)',
    'treasury.subject-payment-document': 'Quietanza di un pagamento senza fattura',
    'treasury.instalment-plan-saved': 'Rateazione salvata',
    'treasury.instalment-plan-deleted': 'Rateazione eliminata',
    'treasury.f24-saved': 'F24 salvato',
    'treasury.f24-deleted': 'F24 eliminato',
    'treasury.subject-statement-exported': 'Scheda contabile esportata in PDF o Excel',
    'treasury.bank-movements-exported': 'Movimenti bancari esportati in CSV',
    'treasury.card-movements-exported': 'Spese delle carte esportate in CSV',
    'reclass.plan-saved': 'Piano riclassificato salvato',
    'reclass.plan-deleted': 'Piano riclassificato tolto',
    'reclass.item-saved': 'Voce del piano riclassificato salvata',
    'reclass.item-removed': 'Voce del piano riclassificato tolta',
    'reclass.items-imported': 'Piano riclassificato importato da CSV',
    'reclass.items-ordered': 'Voci del piano riclassificato riordinate',
    'people.employee-created': 'Nuovo dipendente',
    'people.employee-updated': 'Dipendente aggiornato',
    'people.salary-saved': 'Stipendio caricato',
    'people.salary-payment-added': 'Pagamento dello stipendio segnato',
    'people.salary-payment-removed': 'Pagamento dello stipendio tolto',
    'people.tfr-payment-added': 'Versamento del TFR al fondo collegato',
    'people.tfr-payment-removed': 'Versamento del TFR al fondo tolto',
    'people.tfr-coverage-saved': 'Periodo coperto dal TFR indicato',
    'people.payroll-loaded': 'Paghe del mese caricate',
    'people.payroll-replaced': 'Paghe del mese ricaricate',
    'people.rate-added': 'Costo del collaboratore aggiunto',
    'people.rate-updated': 'Costo del collaboratore modificato',
    'people.rate-removed': 'Costo del collaboratore tolto',
    'job.created': 'Nuova commessa o progetto',
    'job.updated': 'Commessa o progetto aggiornato',
    'job.people-changed': 'Figure della commessa cambiate',
    'job.state-changed': 'Stato della commessa cambiato',
    'job.deleted': 'Commessa o progetto eliminato',
    'job.offer-linked': 'Offerta collegata alla commessa',
    'job.offer-unlinked': 'Offerta tolta dalla commessa',
    'job.child-created': 'Nuova sottocommessa',
    'job.installment-saved': 'Rata della commessa salvata',
    'job.installment-removed': 'Rata della commessa tolta',
    'job.installment-moved': 'Rata della commessa spostata',
    'job.installment-released': 'Via libera alla rata',
    'job.cost-released': 'Via libera al costo',
    'job.installment-proforma-linked': 'Pro-forma collegata alla rata',
    'job.installment-proforma-unlinked': 'Pro-forma scollegata dalla rata',
    'job.cost-proforma-linked': 'Pro-forma collegata al costo',
    'job.cost-proforma-unlinked': 'Pro-forma scollegata dal costo',
    'job.invoice-allocated': 'Fattura divisa sulle commesse',
    'job.cost-saved': 'Costo della commessa salvato',
    'job.cost-settled': 'Costo della commessa saldato',
    'job.cost-reopened': 'Saldo del costo tolto',
    'job.cost-removed': 'Costo della commessa tolto',
    'job.cost-moved': 'Costo della commessa spostato',
    'job.indicator-added': 'Indicatore del progetto aggiunto',
    'job.indicator-updated': 'Indicatore del progetto modificato',
    'job.indicator-removed': 'Indicatore del progetto tolto',
    'job.measure-added': 'Misura di un indicatore aggiunta',
    'job.measure-removed': 'Misura di un indicatore tolta',
    'project-area.access-changed': 'Accessi a un’area dei progetti cambiati',
    'job.resources-changed': 'Persone della commessa o del progetto cambiate',
    'job.hours-added': 'Ore lavorate inserite',
    'job.hours-removed': 'Ore lavorate tolte',
    'job.hours-synced': 'Ore da K-Presenze aggiornate',
    'job.progress': 'Avanzamento (SAL) aggiornato',
    'job.risk-added': 'Rischio o problema aggiunto',
    'job.risk-updated': 'Rischio o problema aggiornato',
    'job.invoice-excluded': 'Fattura segnata «Non riguarda commesse»',
    'job.invoice-included': 'Fattura di nuovo tra quelle delle commesse',
    'job.invoice-dismissed': 'Fattura tolta dalle fatture da abbinare della commessa',
    'job.invoice-restored': 'Fattura di nuovo tra quelle da abbinare della commessa',
    'treasury.schedule-updated': 'Scadenza riprogrammata nello scadenzario',
    'treasury.planned-transfer-created': 'Giroconto programmato',
    'treasury.planned-transfer-updated': 'Giroconto programmato modificato',
    'treasury.planned-transfer-deleted': 'Giroconto programmato eliminato',
    'treasury.planned-transfer-done': 'Giroconto programmato eseguito',
};
//# sourceMappingURL=audit-contracts.js.map